import React, { useRef, useEffect } from "react";
import videoFile from "../../components/money.mp4";
import audioFile from "../../components/collection.m4a";

function CollectionRemoval() {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  useEffect(() => {
      const playMedia = async () => {
        if (videoRef.current && audioRef.current) {
          try {
            await videoRef.current.play();
            await audioRef.current.play();
          } catch (error) {
            console.log("Autoplay blocked by browser, user interaction needed.");
          }
        }
      };
      playMedia();
    }, []);

  return (
    <div className="container">
      <div className="banner" onClick={handlePlay}>
        <video
          ref={videoRef}
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
          className="video"
        />
      </div>

      <audio ref={audioRef} src={audioFile} />

      <div className="container_body">
        <div className="course">
          <h1>How to Delete Collection Removal</h1>
          <p>
            Take Charge of Your Credit! 🧾💥 Join our expert guest Regine Mazile
            as she walks us through effective strategies to delete collections
            from your credit report. Learn the insider techniques, consumer
            laws, and step-by-step processes that can help you clear your report
            and boost your score. It’s time to reclaim your financial freedom!
            💳✨ #CreditRepair #DeleteCollections
          </p>
        </div>
      </div>
    </div>
  );
}

export default CollectionRemoval;
